module.exports = __webpack_public_path__ + "img/bg-withdraw.7e013801.svg";